module.exports = __webpack_public_path__ + "static/assets/95811ff827791d329f030b2db7c0b93a.svg";